import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Alert } from '@/components/atoms/Alert';
import { useRegisterUser } from '@/domain/auth';
import useQueryParams from '@/hooks/useQueryParams';

import { PublicVideoLayout } from '../PublicVideoLayout';

import { UserRegister } from './UserRegister';

export function UserRegisterContainer() {
    const { t } = useTranslation();
    const registerUser = useRegisterUser();
    const [params] = useQueryParams();
    const navigate = useNavigate();

    if (typeof params.token !== 'string') {
        return (
            <PublicVideoLayout>
                <Alert tone="danger">{t('publicPages.userRegister.noToken')}</Alert>
            </PublicVideoLayout>
        );
    }

    return (
        <UserRegister
            onSubmit={async (inputs) => {
                await registerUser(inputs);
                setTimeout(() => navigate('/'), 5000);
            }}
            token={params.token}
        />
    );
}
